import { useT } from "../../i18n/LanguageProvider";
import { localDayKey } from "../../utils/dayKey";
import type { OrderWhen } from "./orderWhen";

/**
 * Day + time of a scheduled order — ONE implementation for the kiosk's two
 * order doors: Orders → New order (G-46) and the Sales ticket's Schedule
 * order (G-112). The date input opens the tablet browser's calendar pop-up;
 * a past day is not offered (the server refuses one too).
 */
export function OrderWhenFields({
  idPrefix,
  value,
  onChange,
  disabled,
}: {
  idPrefix: string;
  value: OrderWhen;
  onChange: (next: OrderWhen) => void;
  disabled?: boolean;
}) {
  const { t } = useT();
  const patch = (partial: Partial<OrderWhen>) => onChange({ ...value, ...partial });
  return (
    <>
      <div className="field">
        <label htmlFor={`${idPrefix}-day`}>{t("orderCreate.day")}</label>
        <input
          id={`${idPrefix}-day`}
          type="date"
          value={value.day}
          min={localDayKey(new Date())}
          onChange={(e) => patch({ day: e.target.value })}
          disabled={disabled}
        />
      </div>
      <div className="field">
        <label>{t("orderCreate.time")}</label>
        <div className="button-row">
          {(
            [
              ["ASAP", "orderCreate.anyTime"],
              ["EXACT", "orderCreate.exactTime"],
              ["WINDOW", "orderCreate.window"],
            ] as const
          ).map(([timeType, label]) => (
            <button
              key={timeType}
              type="button"
              className={value.timeType === timeType ? "button" : "button tinted"}
              onClick={() => patch({ timeType })}
              disabled={disabled}
            >
              {t(label)}
            </button>
          ))}
        </div>
        {value.timeType !== "ASAP" ? (
          <div className="button-row order-when-times">
            <input
              type="time"
              aria-label={
                value.timeType === "WINDOW"
                  ? t("orderCreate.timeFrom")
                  : t("orderCreate.timeAt")
              }
              value={value.timeFrom}
              onChange={(e) => patch({ timeFrom: e.target.value })}
              disabled={disabled}
            />
            {value.timeType === "WINDOW" ? (
              <>
                <span className="muted">{t("orderCreate.untilLower")}</span>
                <input
                  type="time"
                  aria-label={t("orderCreate.until")}
                  value={value.timeUntil}
                  onChange={(e) => patch({ timeUntil: e.target.value })}
                  disabled={disabled}
                />
              </>
            ) : null}
          </div>
        ) : null}
      </div>
    </>
  );
}
